// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2H-aC","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1yFby"};